"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Subscription = (function () {
    function Subscription(subscriber) {
        this.subscriber = subscriber;
        this.eventType = '';
        this.index = -1;
    }
    Subscription.prototype.remove = function () {
        if (this.subscriber) {
            this.subscriber.removeSubscription(this);
            this.subscriber = null;
        }
    };
    return Subscription;
}());
exports.default = Subscription;
//# sourceMappingURL=baseSubscription.js.map